import { useTranslation, withTranslation } from 'react-i18next';
import React, { useEffect, useRef, useState } from 'react';
import Carousel from 'react-slick';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import PropTypes from 'prop-types';

import { useProductPageBanner } from '@hooks/promotion-hook';

import styles from './product-banner.module.scss';

const ProductBanner = ({ prefix, raffleContent = {} }) => {
    const { productBannerByProductPage } = useProductPageBanner();
    const [productBanner, setProductBanner] = useState([]);
    const carouselRef = useRef(null);
    const { t } = useTranslation();

    useEffect(() => {
        if (productBannerByProductPage && prefix) {
            if (prefix) {
                // Filter banners based on conditions
                const filteredBanner = (productBannerByProductPage[prefix] || []).filter((banner) => {
                    const now = new Date();

                    // Check startDate: Exclude if it's in the future
                    const isStarted = banner.startDate ? new Date(banner.startDate) <= now : true;

                    // Check endDate: Exclude if it's expired
                    const isNotExpired = banner.endDate ? new Date(banner.endDate) > now : true;

                    // Check url & webPUrl: Exclude if both are empty
                    const hasValidImage = banner.url || banner.webPUrl;

                    return isStarted && isNotExpired && hasValidImage;
                });
                setProductBanner(filteredBanner);
            } else {
                console.warn(`Invalid prefix: ${prefix}. No matching category found.`);
            }
        }
    }, [productBannerByProductPage, prefix]);

    const sliderSettings = {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: productBanner.length > 1,
        infinite: productBanner.length > 1,
        arrows: true,
        dots: true,
        className: 'slider',
        dotsClass: styles.dotsContainer,
        appendDots: (dots) => (
            <div className={styles.dotsContainer}>
                {dots.map((item, index) => (
                    <button
                        key={index}
                        onClick={() => carouselRef.current?.slickGoTo(index)}
                        className={item.props.className === 'slick-active' ? styles.active : styles.dots}
                        aria-label={`slide ${index + 1} bullet`}
                    ></button>
                ))}
            </div>
        ),
    };

    const handleBannerClick = (href) => {
        if (href) {
            if (!href.startsWith('/')) {
                window.open(href, '_blank', 'noopener,noreferrer');
            } else {
                window.location.href = href;
            }
        }
    };

    return (
        <div className={styles.productBannerWrapper}>
            <div className={styles.productBannerContainer}>
                {productBanner?.length > 0 && (
                    <Carousel ref={carouselRef} {...sliderSettings}>
                        {productBanner.map((banner, index) => (
                            <div className={styles.bannerImgContainer} key={index} onClick={() => banner.href && handleBannerClick(banner.href)}>
                                <LazyLoadImage src={banner.webPUrl || banner.url} alt='banner-img' className={styles.bannerImg} />
                            </div>
                        ))}
                    </Carousel>
                )}
                {Object.keys(raffleContent).length > 0 && (
                    <div className='raffle-countdown'>
                        <LazyLoadImage src='/public/html/images/slot_img/096-raffleDraw-timeBox.png' alt='raffle-timebox' />

                        <div className='countdown'>
                            <ul>
                                <li>
                                    <span>{raffleContent?.days > 0 ? raffleContent.days : 0}</span>
                                    <span>{t('global:global.messages.maintenance.day', 'DAYS')}</span>
                                </li>
                                <li>
                                    <span>{raffleContent?.hours > 0 ? raffleContent.hours : 0}</span>
                                    <span>{t('global:global.messages.maintenance.hour', 'HOURS')}</span>
                                </li>
                                <li>
                                    <span>{raffleContent?.mins > 0 ? raffleContent.mins : 0}</span>
                                    <span>{t('global:global.messages.maintenance.minute', 'MINS')}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

ProductBanner.propTypes = {
    prefix: PropTypes.string,
    raffleContent: PropTypes.shape({
        isRafflePage: PropTypes.bool,
        raffleTime: PropTypes.shape({
            days: PropTypes.number,
            hours: PropTypes.number,
            mins: PropTypes.number,
        }),
    }),
};

export default withTranslation([])(ProductBanner);
